<div class="skeleton-container">
  <div class="skeleton">
    <div class="skeleton__header">
      <span pdsSkeleton [height]="'18px'" [width]="'40%'" color="primary"></span>
    </div>
    <div class="skeleton__content">
      <span pdsSkeleton [height]="'18px'"></span>
      <span pdsSkeleton [height]="'18px'" [width]="'60%'"></span>
      <span pdsSkeleton [height]="'18px'" [width]="'80%'"></span>
    </div>
  </div>
</div>
